module.exports = __webpack_public_path__ + "static/media/help-tap-to-fill.d32272e3.png";